export default "__VITE_ASSET__d9cca8b3__"